'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _invertBy2 = require('lodash/invertBy');

var _invertBy3 = _interopRequireDefault(_invertBy2);

var _findIndex3 = require('lodash/findIndex');

var _findIndex4 = _interopRequireDefault(_findIndex3);

var _desc, _value, _class; /**
                           * Parent class for selectable lists
                            * don't forget to set selectable config and this.onSelectionChange(itemsArray) method in child class
                            * see this.selectableConfig params in constructor
                           * */

var _react = require('react');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SelectableList = (_class = function (_PureComponent) {
  (0, _inherits3.default)(SelectableList, _PureComponent);

  function SelectableList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SelectableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectableList.__proto__ || (0, _getPrototypeOf2.default)(SelectableList)).call.apply(_ref, [this].concat(args)));

    _this.state = { checkedItems: {} };
    _this.selectableConfig = {
      idField: 'id', // id field name
      propsField: 'items', // this.props field of selectable items (array)
      resultAsIndexes: false, // [1, 3, 5, 6] instead of [id1, id3, id5, id6]
      idAsString: false, // type of id = string
      checkedItemsPropsField: null, // if null state is used
      updateFn: null // function to update state with checked songs, used setState if null
    };
    return _this;
  }

  (0, _createClass3.default)(SelectableList, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.updateCheckedItems({});
    }
  }, {
    key: 'onSelectAllClick',
    value: function onSelectAllClick() {
      var isAllItemsSelected = this.state.isAllItemsSelected;

      if (isAllItemsSelected) {
        this.selectNone();
      } else {
        this.selectAll();
      }
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      var _this2 = this;

      var checkedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var listItems = this.props[this.selectableConfig.propsField];
      var checkedArray = this.getCheckedItemsArray(checkedItems);
      var result = checkedArray;

      if (this.selectableConfig.resultAsIndexes) {
        result = [];
        checkedArray.map(function (itemId) {
          var index = (0, _findIndex4.default)(listItems, (0, _defineProperty3.default)({}, _this2.selectableConfig.idField, itemId)) + 1;
          result.push(index);
        });
      }
      if (this.onSelectionChange) {
        this.onSelectionChange(result);
      }
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.selectableConfig = (0, _extends4.default)({}, this.selectableConfig, config);
    }
  }, {
    key: 'getStateCheckedItems',
    value: function getStateCheckedItems() {
      var checkedItemsPropsField = this.selectableConfig.checkedItemsPropsField;

      return checkedItemsPropsField ? this.props[checkedItemsPropsField] : this.state.checkedItems;
    }
  }, {
    key: 'getCheckedItemsArray',
    value: function getCheckedItemsArray(checkedItems) {
      var itemsArr = (0, _invertBy3.default)(checkedItems || this.getStateCheckedItems() || {}).true || [];
      return this.selectableConfig.idAsString ? itemsArr : itemsArr.map(Number);
    }
  }, {
    key: 'toggleItemChecked',
    value: function toggleItemChecked(id) {
      var listItems = this.props[this.selectableConfig.propsField];
      var stateCheckedItems = this.getStateCheckedItems();

      var checkedItems = (0, _extends4.default)({}, stateCheckedItems, (0, _defineProperty3.default)({}, id, !stateCheckedItems[id]));
      var checkedItemsArr = this.getCheckedItemsArray(checkedItems);
      this.setState({ isAllItemsSelected: checkedItemsArr.length === listItems.length });
      this.updateCheckedItems(checkedItems);
      this.onSelect(checkedItems);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var _this3 = this;

      var listItems = this.props[this.selectableConfig.propsField];
      var checkedItems = {};
      listItems.map(function (item) {
        return checkedItems[item[_this3.selectableConfig.idField]] = true;
      });
      this.setState({ isAllItemsSelected: true });
      this.updateCheckedItems(checkedItems);
      this.onSelect(checkedItems);
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      this.setState({ isAllItemsSelected: false });
      this.updateCheckedItems({});
      this.onSelect({});
    }
  }, {
    key: 'updateCheckedItems',
    value: function updateCheckedItems(checkedItems) {
      var updateFn = this.selectableConfig.updateFn;

      if (updateFn) {
        updateFn(checkedItems);
      } else {
        this.setState({ checkedItems: checkedItems });
      }
    }
  }]);
  return SelectableList;
}(_react.PureComponent), (_applyDecoratedDescriptor(_class.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectAllClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectAll'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectNone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectNone'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCheckedItems', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCheckedItems'), _class.prototype)), _class);
exports.default = SelectableList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectableList/SelectableList.js
// module id = 354
// module chunks = 1